(function ($) {
  window.vimeoObserver = window.vimeoObserver || new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var vid = entry.target.id.replace("vimeo-", "");
      if (entry.isIntersecting) {
        window.vimeo[vid].play();
        window.vimeo[vid].setVolume(1);
      } else {
        window.vimeo[vid].pause();
      }
    });
  });
  $('.vimeoplayer').each(function (index) {
    var playerdiv = $(this);
    var videourl = playerdiv.attr("data-url");
    var videoid = videourl.replace("https://vimeo.com/", "").split("/");
    var playerid = "vimeo-" + videoid[0];
    var language = 'fr';
    if (document.documentElement.getAttribute('lang') && document.documentElement.getAttribute('lang') === 'en-CA') {
      language = 'en';
    }
    window.vimeo = window.vimeo || {};
    playerdiv.attr("id", playerid);
    playerobj = new Vimeo.Player(playerid, {
      url: videourl,
      controls: true,
      loop: true,
      cc: true,
      texttrack: language
    });
    window.vimeo[videoid[0]] = playerobj;
    vimeoObserver.observe(playerdiv[0]);
  });
})(jQuery);